import React from "react";
import ModalLauncher from "./ModalLauncher";

export default class ImportNew extends ModalLauncher {
  static defaultProps = {
    text: "  Import Part",
    buttonClass: "btn-info",
    spanClass: "input-group-btn"
  };

  render() {
    return <span className={this.props.spanClass}>{this.button()}</span>;
  }
}



// WEBPACK FOOTER //
// ./app/modules/shared/containers/ImportNew.jsx